import { render, staticRenderFns } from "./VirtualCard.vue?vue&type=template&id=0f1022d7&scoped=true&"
import script from "./VirtualCard.vue?vue&type=script&lang=js&"
export * from "./VirtualCard.vue?vue&type=script&lang=js&"
import style0 from "./VirtualCard.vue?vue&type=style&index=0&id=0f1022d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1022d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VOverlay,VProgressCircular,VRow,VSnackbar})
